'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setWindowSize = exports.getWindowSize = exports.SET_WINDOW_SIZE = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = require('reselect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SET_WINDOW_SIZE = exports.SET_WINDOW_SIZE = 'la/ui/windowSize/SET';

// reducer
var DEFAULT_STATE = {
    height: 1024,
    width: 1024
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SET_WINDOW_SIZE:
            return (0, _extends3.default)({}, state, {
                height: action.payload.height,
                width: action.payload.width
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.windowSize;
};

var getWindowSize = exports.getWindowSize = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var setWindowSize = exports.setWindowSize = function setWindowSize(_ref) {
    var height = _ref.height,
        width = _ref.width;
    return {
        payload: { height: height, width: width },
        type: SET_WINDOW_SIZE
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/windowSize.js
// module id = rVZG
// module chunks = 46